<button
    class="special-menu-item"
    [style]="
      '--special-menu-item-filter-color: ' + filterColor() + ';' +
      '--special-menu-item-linear-gradient: ' + linearGradient()"
    type="button"
    (click)="click()"
>
    <ls-picture
        class="special-menu-item__bg"
        [height]="92"
        [lazy]="true"
        [src]="bgUrl()"
        [width]="552"
    />
    <ls-picture
        class="special-menu-item__icon"
        [height]="30"
        [lazy]="true"
        [src]="iconUrl()"
        [width]="30"
    />
    <span class="special-menu-item__name _system-sub-sm _800">{{ name() | translate }}</span>
</button>
